var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_16727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26512 0.381592C3.84712 0.381592 0.265625 3.96309 0.265625 8.38159C0.265625 12.6716 3.64313 16.1731 7.88425 16.3718C8.01067 16.3778 8.13762 16.3809 8.26512 16.3811C10.2326 16.3838 12.1316 15.6587 13.5966 14.3455C12.6591 14.9671 11.5625 15.325 10.391 15.325C8.48575 15.325 6.77962 14.3797 5.63225 12.8895C4.7475 11.8455 4.17475 10.3021 4.13562 8.56959V8.19309C4.17475 6.46072 4.7475 4.91722 5.63225 3.87322C6.77975 2.38259 8.48588 1.43772 10.3906 1.43772C11.5625 1.43772 12.6591 1.79559 13.5971 2.41772C12.1885 1.15797 10.332 0.389342 8.29537 0.381592H8.26512Z",
    fill: "url(#paint0_linear_4069_16727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63281 3.87373C6.36669 3.00698 7.31494 2.48411 8.35056 2.48411C10.6797 2.48411 12.5673 5.12473 12.5673 8.38161C12.5673 11.6385 10.6796 14.2791 8.35056 14.2791C7.31494 14.2791 6.36669 13.7566 5.63281 12.89C6.78031 14.3807 8.48631 15.3255 10.3916 15.3255C11.5634 15.3255 12.6597 14.9676 13.5972 14.346C15.2349 12.8811 16.2657 10.7517 16.2657 8.38161C16.2657 6.01148 15.2349 3.88311 13.5977 2.41823C12.6602 1.79611 11.5636 1.43823 10.3917 1.43823C8.48644 1.43823 6.78031 2.38348 5.63294 3.87373",
    fill: "url(#paint1_linear_4069_16727)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4069_16727",
    x1: 6.9315,
    y1: 0.642467,
    x2: 6.9315,
    y2: 16.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4069_16727",
    x1: 10.9489,
    y1: 1.55661,
    x2: 10.9489,
    y2: 15.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_16727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.265625 0.380615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.b9b5341c7ac5757557dce66e6543f637.svg";
export { ForwardRef as ReactComponent };